import { type CustomerId, type EventId, type SiteId } from '@solinkcorp/api-types';
import { useUserSession } from '@solinkcorp/authentication';
import { CallhomeApi } from 'clients';
import MonitorCentreApi from 'clients/MonitorCentreApi';
import { useCallback } from 'react';
import { userHasVerifEyeGroups } from 'utils/AlarmUtil';

export default function useAlarmEditEvent() {
  const user = useUserSession();
  const callHomeApi = CallhomeApi(user.accessToken);

  return useCallback(
    (
      eventId: EventId,
      customerId: CustomerId,
      siteId: SiteId,
      payload: Record<string, string>[] | Record<string, string>,
      editTemplateId: string,
    ) => {
      if (userHasVerifEyeGroups(user)) {
        const username = `${user.profile.name} (${user.profile.email})`;
        return MonitorCentreApi.editAlarmEvent({
          jwt: user.accessToken,
          eventId,
          username,
          customerId,
          siteId,
          payload,
          editTemplateId,
        });
      }
      return callHomeApi.editAlarmEvent({ eventId, siteId, payload });
    },
    [callHomeApi, user],
  );
}
